import { render } from "./GoogleAuthRedirect.vue?vue&type=template&id=fecc418c&scoped=true"
import script from "./GoogleAuthRedirect.vue?vue&type=script&lang=js"
export * from "./GoogleAuthRedirect.vue?vue&type=script&lang=js"

import "./GoogleAuthRedirect.vue?vue&type=style&index=0&id=fecc418c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fecc418c"]])

export default __exports__